/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Pipe, PipeTransform } from '@angular/core';
import { InterpolationData } from '@common';
import { TranslateService } from '../../services/translate/translate.service';

@Pipe({
  name: 'translate',
  standalone: true,
})
export class TranslatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(
    translationId: string,
    interpolationData?: InterpolationData,
  ): string | any {
    return this.translateService.translate(translationId, interpolationData);
  }
}
